import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PaginatedResponse } from '../../interfaces/pagination';
import { VisibilityConnection } from '../../../pages/search/models/user-suggestion';
import { DestroyBase } from '../../base-classes/destroy-component-base';

@Injectable({
  providedIn: 'root',
})
export class RecordVisibilityService extends DestroyBase {
  private apiUrl = environment.apiBaseUrl;
  private http = inject(HttpClient);

  updateRecordVisibility(
    uniqueId: string,
    payload: {
      visibility_mode: number;
      include_connections: number[];
      exclude_connections: number[];
    },
  ): Observable<unknown> {
    return this.http.patch(
      `${this.apiUrl}/api/record/${uniqueId}/visibility`,
      payload,
    );
  }

  getRecordConnections(
    uniqueId: string,
    searchKey: string,
    page = 1,
    pageSize = 10,
  ): Observable<PaginatedResponse<VisibilityConnection>> {
    let params = new HttpParams();
    if (searchKey) {
      params = params.set('search_key', searchKey);
    }
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    return this.http.get<PaginatedResponse<VisibilityConnection>>(
      `${this.apiUrl}/api/record/${uniqueId}/visibility/connections`,
      { params },
    );
  }

  getRecordVisibility(uniqueId: string): Observable<VisibilityConnection[]> {
    return this.http.get<VisibilityConnection[]>(
      `${this.apiUrl}/api/record/${uniqueId}/visibility`,
    );
  }
}
